export default class ListAttachmentRecordsByParentIdError extends Error {

}
